export default __webpack_public_path__ + "static/media/YellowCircle.85b8265b.svg";